<template>
  <div v-if="!inWeixin || !isMiniProgram">
    <li style="width: 100%;border-bottom: 1px solid #eee;margin-bottom: 20px;"></li>
    <li class="other_login">
      <span class="sec_word">第三方登录</span>
      <!-- <router-link
        to="/register/proinfo"
        class="login_weixin"
        :target="isApps === 1 ? '':'_blank'"
      >
        <i class="iconfont icon-weixin"></i>
      </router-link>
      <router-link
        to="/register/proinfo"
        class="login_qq"
        :target="isApps === 1 ? '':'_blank'"
      >
        <i class="iconfont icon-QQ"></i>
      </router-link>
      <router-link
        to="/register/proinfo"
        class="login_weibo"
        :target="isApps === 1 ? '':'_blank'"
      >
        <i class="iconfont icon-weibo"></i>
      </router-link> -->
      <!-- /register/proinfo -->
      <a
        href="javascript:;"
        class="login_zhifubao"
        @click="zhifubaoLogin"
      >
        <i class="iconfont icon-zhifubao-copy-copy-copy-copy"></i>
      </a>
    </li>
  </div>
</template>

<script>
  export default {
    data () {
      return {
        isApps: 2,
        authCode: '',
        productId: '',
        pathInfo: '',
      }
    },
    mounted () {
      let isApp = this.appConfig.checkBoxs.checkBox();
      if (isApp === "browser") {
        this.isApps = 1;
      } else if (isApp === "app") {
        this.isApps = 2;
      }
      let that = this
      if (this.isZhifubao) {
          // console.log(my)
          my.onMessage = function (e) {
            my.showLoading()
              that.authCode = e.sendToWebView
              // my.alert({
              //   content: that.authCode
              // })
              if (that.authCode) {
                window.localStorage.setItem('is-first-open-mini', 1)
              }
              that.miniLogin(that.authCode)
          }
          // my.postMessage("{'sendToMiniProgram': '0'}");
          //   this.getZhifubaoAuthCode()
          if (!window.localStorage.getItem('is-first-open-mini')) this.zhifubaoLogin()
      }
      this.productId = this.$route.params.productId;
      this.pathInfo = this.$route.params.pathInfo;
    },
    methods: {
      miniLogin (authCode) {
        let that = this
        let apiUrl = this.appConfig.apiHost + "/v1/app/customer/third-login/"
        this.axios.post(apiUrl, {
          auth_code: authCode,
          channel: 'alilogin',
          client: 'mini'
        }).then(res => {
          // alert(res.data.code)
          // alert(res.data.message)
          // my.alert({
          //   content: res.data.code
          // })
          if (res.data.code === 200) {
            if (this.$route.params.productId || this.$route.params.pathInfo) {
              that.$router.replace({
                path: this.$route.params.pathInfo,
                query: { productId: this.$route.params.productId },
              });
            } else {
              that.$router.replace({ name: "me" });
            }
          } else if (res.data.code === 20400) {
            this.$router.replace({ path: '/register/bind_phone', query: { account_id: res.data.data.account_id, productId: this.productId, pathInfo: this.pathInfo } })
          }
          my.hideLoading()
          // alert(JSON.stringify(res.data.data))
        })
        .catch(err => {
          my.hideLoading()
        })
      },
      zhifubaoLogin () {
        // var parseQuery = function getQueryString(name) {
        //   var reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)', 'i');
        //   //正则解释：()为分组，是哪个括号三个分组，|表示或者关系，[^&]表示不含&符号，'i'为忽略大小写参数
        //   var r = window.location.search.substr(1).match(reg);
        //   if (r != null) {
        //     return unescape(r[2]); //unescape()将url编码字符串转换为正常编码。
        //   }
        //   return null;
        // }
        if (this.isZhifubao) {
          my.postMessage("{'sendToMiniProgram': '0'}");
        } else {
          let apiUrl = this.appConfig.apiHost + "/v1/app/customer/get-auth-url/?channel=alilogin"
          this.axios.get(apiUrl).then(res => {
            console.log(res)
            if (res.data.code === 200) {
              window.location.href = res.data.data.url
              // console.log(res.data.data.url)
              // let query = res.data.data.url.split('?')[1]
              // console.log(query)
              // console.log(parseQuery(query))
            }
          })
        }
      },
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/center/login/thirdLogin.vue